import React from 'react'
import { NavLink, Route, Routes } from 'react-router-dom'
import { useSelector } from 'react-redux'

import ProfileView from './ProfileView'
import ChangePassword from './ChangePassword/ChangePassword'
import Wishlist from './Wishlist/Wishlist'

import ProfileImage from '../../../Assets/images/profile-pic.png'

import './Profile.css'

function Profile() {
    const { consumer } = useSelector(state => state.auth)

    return (
        <section className='profile_view_page page_padding ss_page'>
            <div className="container">
                <div className="ph_wrapper">
                    <h1 className="page_heading">
                        {
                            consumer
                                ?
                                consumer.language === 'english'
                                    ?
                                    'Profile'
                                    :
                                    'প্রোফাইল'
                                :
                                'প্রোফাইল'
                        }
                    </h1>
                </div>
                <div className="pp_wrapper">
                    <img src={ProfileImage} alt="profile thumb" />
                </div>
                <div className="tabs_contents">
                    <ul className="tabs_wrapper">
                        <li className="tab_item">
                            <NavLink to='my-profile'>
                                {
                                    consumer
                                        ?
                                        consumer.language === 'english'
                                            ?
                                            'Your Profile'
                                            :
                                            'আপনার প্রোফাইল'
                                        :
                                        'আপনার প্রোফাইল'
                                }
                                </NavLink>
                        </li>
                        <li className="tab_item">
                            <NavLink to='change-password'>
                                {
                                    consumer
                                        ?
                                        consumer.language === 'english'
                                            ?
                                            'Change Password'
                                            :
                                            'পাসওয়ার্ড পরিবর্তন করুন'
                                        :
                                        'পাসওয়ার্ড পরিবর্তন করুন'
                                }
                                </NavLink>
                        </li>
                        <li className="tab_item">
                            <NavLink to='favorite'>
                                {
                                    consumer
                                        ?
                                        consumer.language === 'english'
                                            ?
                                            'Favorites'
                                            :
                                            'পছন্দের তালিকা'
                                        :
                                        'পছন্দের তালিকা'
                                }
                                </NavLink>
                        </li>
                    </ul>
                </div>
                <Routes>
                    <Route path='my-profile' element={<ProfileView />} />
                    <Route path='change-password' element={<ChangePassword />} />
                    <Route path='favorite' element={<Wishlist />} />
                </Routes>
            </div>
        </section>
    )
}

export default Profile